import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useApi, errMsg } from "@/lib/api";

export const DocumentViewer = ({ userId, kind, title, onClose }) => {
  const api = useApi();
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let url;
    api("get", `/documents/${userId}/${kind}`, null, { responseType: "blob" })
      .then((blob) => { url = URL.createObjectURL(blob); setFile({ url, pdf: blob.type === "application/pdf" }); })
      .catch((e) => setError(errMsg(e)));
    return () => url && URL.revokeObjectURL(url);
  }, [api, userId, kind]);

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="document-viewer-dialog" className="sm:max-w-3xl">
        <DialogHeader><DialogTitle className="font-heading">{title}</DialogTitle></DialogHeader>
        {error && <p className="text-rose-600 text-sm">{error}</p>}
        {!file && !error && <p className="text-slate-500 text-sm">Caricamento...</p>}
        {file && (file.pdf
          ? <iframe title={title} src={file.url} className="w-full h-[70vh] rounded-lg border" data-testid="document-viewer-pdf" />
          : <img src={file.url} alt={title} className="max-h-[70vh] mx-auto rounded-lg" data-testid="document-viewer-image" />)}
      </DialogContent>
    </Dialog>
  );
};
